import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button } from '@optimus-web/core';
import { ConfirmationDialog } from '@mews-commander/ui';
import { initCustomerDetail } from '../../../customerDetail/actions/init';

interface CustomerClearDataDialogProps {
    id: string;
}
export const CustomerClearDataDialog = ({ id }: CustomerClearDataDialogProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch();

    const clearData = () => {
        dispatch(initCustomerDetail({ scope: '', id }));
    };
    const openDialog = () => {
        setIsOpen(true);
    };

    const closeDialog = () => {
        setIsOpen(false);
    };

    return (
        <>
            <Button onClick={openDialog} type="submit">
                {lt('AssistantSummaryGuestClearData')}
            </Button>
            <ConfirmationDialog
                confirmationOpened={isOpen}
                confirmChange={clearData}
                cancelChange={closeDialog}
                textKey={TextKey.ClearCustomerProfile}
                content={lt('ClearCustomerProfileQuestion')}
            />
        </>
    );
};
